export const PROJECT_MAX_FILES = 5;
const MAX_BYTES = 500 * 1024 * 1024;
const EXTENSIONS = new Set('jpg jpeg png gif webp bmp tif tiff heic heif svg pdf doc docx xls xlsx ppt pptx txt csv md rtf odt ods odp zip json mp4 mov webm avi mkv m4v mp3 wav ogg oga m4a aac opus'.split(' '));

export function validateProjectFiles(files, count = 0) {
    if (files.length + count > PROJECT_MAX_FILES) return 'Maximum 5 fichiers par message.';
    for (const file of files) {
        if (!EXTENSIONS.has(file.name.split('.').pop().toLowerCase())) return `Format non accepté : ${file.name}`;
        if (!file.size) return `Le fichier ${file.name} est vide.`;
        if (file.size > MAX_BYTES) return 'Chaque fichier est limité à 500 Mo.';
    }
    return null;
}